import React from 'react';

const LogInInstead = ({ toggleSignUpOpen, border }) => (
	<div style={{
		 width: '100%', marginTop: '1rem', paddingTop: '1rem', textAlign: 'center',
	}}
	>
		<p style={{ color: '#666666' }}> Already have an account? <span className="secondary-color"><a className="secondary-a" href="#" onClick={() => toggleSignUpOpen()}>Log In </a></span> </p>
	</div>
);

export default LogInInstead;
